import CertsListNoRecordsFound from './CertsListNoRecordsFound';

export default CertsListNoRecordsFound;
